/**
 * Loads JS and CSS for a block.
 * @param {Element} block The block element
 */
export async function loadBlock(block) {
    const status = block.dataset.blockStatus;
    if (status !== 'loading' && status !== 'loaded') {
        block.dataset.blockStatus = 'loading';
        const { blockName } = block.dataset;
        try {
            const decorationComplete = new Promise((resolve) => {
                (async () => {
                    try {
                        const mod = await import(`${window.hlx.codeBasePath}/blocks/${blockName}/${blockName}.js`);
                        if (mod.default) {
                            await mod.default(block);
                        }
                    }
                    catch (error) {
                        // eslint-disable-next-line no-console
                        console.log(`failed to load module for ${blockName}`, error);
                    }
                    resolve();
                })();
            });
            await Promise.all([decorationComplete]);
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.log(`failed to load block ${blockName}`, error);
        }
        block.dataset.blockStatus = 'loaded';
    }
    return block;
}
//# sourceMappingURL=loadBlock.mjs.map